import { environment } from '../../../environments/environment';
import { Utility } from '../utility';

export const emojiMiaoHun = {
    label: '喵魂',
    height: 90,
    width: 90,
    path:"/upload/facetime/miaohun/",
    range:[[20210401,20210424]]
    // items: [
    //     {
    //         'not': 20210401,
    //         'id': 20210401,
    //         'image': '/upload/facetime/miaohun/20210401.gif',
    //         'title': '不要',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210401)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210402,
    //         'id': 20210402,
    //         'image': '/upload/facetime/miaohun/20210402.gif',
    //         'title': '吃瓜',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210402)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210403,
    //         'id': 20210403,
    //         'image': '/upload/facetime/miaohun/20210403.gif',
    //         'title': '吃惊',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210403)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210404,
    //         'id': 20210404,
    //         'image': '/upload/facetime/miaohun/20210404.gif',
    //         'title': '抖眉',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210404)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210405,
    //         'id': 20210405,
    //         'image': '/upload/facetime/miaohun/20210405.gif',
    //         'title': '发抖',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210405)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210406,
    //         'id': 20210406,
    //         'image': '/upload/facetime/miaohun/20210406.gif',
    //         'title': '乖巧',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210406)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210407,
    //         'id': 20210407,
    //         'image': '/upload/facetime/miaohun/20210407.gif',
    //         'title': '哈哈',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210407)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210408,
    //         'id': 20210408,
    //         'image': '/upload/facetime/miaohun/20210408.gif',
    //         'title': '嘿嘿',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210408)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210409,
    //         'id': 20210409,
    //         'image': '/upload/facetime/miaohun/20210409.gif',
    //         'title': '坏笑',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210409)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210410,
    //         'id': 202104010,
    //         'image': '/upload/facetime/miaohun/20210410.gif',
    //         'title': '惊恐',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210410)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210411,
    //         'id': 20210411,
    //         'image': '/upload/facetime/miaohun/20210411.gif',
    //         'title': '就这？',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210411)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210412,
    //         'id': 20210412,
    //         'image': '/upload/facetime/miaohun/20210412.gif',
    //         'title': '冷漠',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210412)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210413,
    //         'id': 20210413,
    //         'image': '/upload/facetime/miaohun/20210413.gif',
    //         'title': '略略略',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210413)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210414,
    //         'id': 20210414,
    //         'image': '/upload/facetime/miaohun/20210414.gif',
    //         'title': '难受',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210414)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210415,
    //         'id': 20210415,
    //         'image': '/upload/facetime/miaohun/20210415.gif',
    //         'title': '色色',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210415)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210416,
    //         'id': 20210416,
    //         'image': '/upload/facetime/miaohun/20210416.gif',
    //         'title': '闪光',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210416)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210417,
    //         'id': 20210417,
    //         'image': '/upload/facetime/miaohun/20210417.gif',
    //         'title': '生气',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210417)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210418,
    //         'id': 20210418,
    //         'image': '/upload/facetime/miaohun/20210418.gif',
    //         'title': '挑眉',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210418)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210419,
    //         'id': 20210419,
    //         'image': '/upload/facetime/miaohun/20210419.gif',
    //         'title': '偷笑',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210419)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210420,
    //         'id': 20210420,
    //         'image': '/upload/facetime/miaohun/20210420.gif',
    //         'title': '吓傻',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210420)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210421,
    //         'id': 20210421,
    //         'image': '/upload/facetime/miaohun/20210421.gif',
    //         'title': '嫌弃',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210421)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210422,
    //         'id': 20210422,
    //         'image': '/upload/facetime/miaohun/20210422.gif',
    //         'title': '嚣张',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210422)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210423,
    //         'id': 20210423,
    //         'image': '/upload/facetime/miaohun/20210423.gif',
    //         'title': '邪恶',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210423)',
            
    //         'GroupID': 202104
    //     },
    //     {
    //         'not': 20210424,
    //         'id': 20210424,
    //         'image': '/upload/facetime/miaohun/20210424.gif',
    //         'title': '右边',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210424)',
            
    //         'GroupID': 202104
    //     },
    // ]
}
